import Event from "./Event";

class Language extends Event {
    constructor() {
        super();
        this.locale = "hu-HU";
        this.currency = "HUF";
    }

    // Creating a global instance
    static createInstance() {
        return new this();
    }

    formatCurrency(number) {
        return new Intl.NumberFormat(this.locale, {
            style: "currency",
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
            currency: this.currency,
            useGrouping: true,
        }).format(number);
    }
}

export default Language;
